import produce from 'immer';

// TYPES
import { Types, ExcluirMensagem } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: ExcluirMensagem = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirMensagem {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_MENSAGEM_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
